import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AiSearchModule } from './AiSearchModule';
import type { AiSearchEntityType, AiSearchResultItem } from '../../services/aiSearchService';

export type AiSearchModalProps = {
  open: boolean;
  onClose: () => void;
  fixedEntityType: AiSearchEntityType;
  diagnosisId?: string;
  onInsert?: (item: AiSearchResultItem) => void | Promise<void>;
};

export const AiSearchModal: React.FC<AiSearchModalProps> = ({
  open,
  onClose,
  fixedEntityType,
  diagnosisId,
  onInsert,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="md"
    scroll="paper"
    slotProps={{
      paper: {
        sx: { height: '85vh', maxHeight: '90vh' },
      },
    }}
  >
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography component="span" variant="h6">
        Ricerca AI
      </Typography>
      <IconButton aria-label="Chiudi" onClick={onClose} size="small">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <AiSearchModule
        variant="modal"
        fixedEntityType={fixedEntityType}
        diagnosisId={diagnosisId}
        onInsert={onInsert}
      />
    </DialogContent>
  </Dialog>
);
